var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"root"},[_c('div',{staticClass:"graphEditor",attrs:{"id":_vm.store.id}})])}
var staticRenderFns = []

export { render, staticRenderFns }